import FlexPane from './_flex-pane.js'
import Image from './_image.js'
import Text from './_text.js'
import ImageButton from './_image-button.js'
import Button from './_button.js'
import Popover from './_popover.js'

export default {
  name: 'OddsBoostBanner',
  values: {
    containerWrapper: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px 0 0 0',
          maxHeight: '56px',
        },
      },
    },
    betBuilderContainerWrapper: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          width: 'calc(100% + 16px)',
          left: '-8px',
          bottom: '-8px',
        },
      },
    },
    container: {
      base: {
        configSet: FlexPane,
        configValues: {
          style: {
            alignItems: 'center',
            padding: '7px 4px 7px 8px',
          },
        },
      },
      APPLIED: {
        configSet: FlexPane,
        configValues: {},
      },
    },
    betBuilderContainer: {
      base: {
        configSet: FlexPane,
        configValues: {
          style: {
            alignItems: 'center',
            padding: '7px 4px 7px 8px',
          },
        },
      },
      APPLIED: {
        configSet: FlexPane,
        configValues: {},
      },
    },
    textContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '0 8px 0 0',
        },
      },
    },
    boostIcon: {
      base: {
        configSet: Image,
        configValues: {
          src: 'promotion-boost',
          style: {
            minWidth: '32px',
            minHeight: '32px',
            width: '32px',
            height: '32px',
            flexShrink: 0,
            padding: '0 8px 0 0',
          },
        },
      },
      disabled: {
        configSet: Image,
        configValues: {
          style: {
            flexShrink: 0,
          },
        },
      },
    },
    title: {
      base: {
        configSet: Text,
        configValues: {},
      },
      IN_USE: {
        configSet: Text,
        configValues: {
          truncate: true,
          ellipsisOnLineNumber: 3,
        },
      },
    },
    returnsText: {
      configSet: Text,
      configValues: {
        truncate: true,
        ellipsisOnLineNumber: 2,
      },
    },
    infoTooltip: {
      infoButton: {
        configSet: ImageButton,
        configValues: {
          button: {
            style: {
              base: {
                padding: '8px',
                flexGrow: 0,
              },
            },
          },
          buttonIcon: {
            src: 'semantic-info',
            style: {
              minWidth: '16px',
              minHeight: '16px',
            },
          },
        },
      },
      title: {
        configSet: Text,
        configValues: {},
      },
      text: {
        configSet: Text,
        configValues: {
          container: {
            padding: '2px 0 0 0',
          },
        },
      },
      expiry: {
        configSet: Text,
        configValues: {
          container: {
            padding: '2px 0 0 0',
          },
        },
      },
    },
    actionButton: {
      base: {
        configSet: Button,
        configValues: {
          style: {
            base: {
              alignItems: 'center',
              minHeight: '40px',
              padding: '8px 12px',
              flexShrink: 0,
              flexGrow: 0,
            },
          },
        },
      },
      AVAILABLE: {
        configSet: Button,
        configValues: {
          style: {
            base: {
              flexShrink: 0,
              flexGrow: 0,
            },
          },
        },
      },
    },
    popover: {
      configSet: Popover,
      configValues: {
        button: {
          style: {
            base: {
              alignSelf: 'auto',
              minWidth: '32px',
              minHeight: '32px',
            },
          },
        },
        container: {
          style: {
            padding: '8px',
          },
        },
        popup: {
          arrowhead: {
            direction: 'down',
          },
          container: {
            style: {
              width: '240px',
              bottom: '38px',
              right: '-34px',
              left: 'auto',
              top: 'auto',
            },
          },
          arrowheadOffset: '-42px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
